import React from "react";
import { Outlet } from "react-router-dom";
import Button from "./Button";
import { Images } from "../assets";
import Loading from "./Loading";
import { useAppContext } from "../providers/AppProvider";

export default function Navbar() {
  return (
    <div className="flex flex-col min-h-[90vh] md:min-h-screen">
      {/* Navbar Header */}
      <Loading />
      <div className="flex justify-between items-center p-3 md:pt-5 md:pb-0">
        <img
          alt="logo"
          src={Images.tcg_logo}
          style={{ height: 27 }}
          className="cursor-pointer"
        />
        <ul className="hidden md:flex gap-8">
          {Object.keys(Navitems).map((navItem) => (
            <a
              key={navItem}
              href={Navitems[navItem as keyof typeof Navitems]}
              className="cursor-pointer"
            >
              {navItem}
            </a>
          ))}
        </ul>
        <Button title="Request a Demo" />
      </div>
      {/* Outlet for Dynamic Routes */}
      <div className="flex-1 flex justify-center items-center p-3">
        <Outlet />
      </div>
    </div>
  );
}

const Navitems = {
  Home: "/",
  "About Us": "/about",
  Solutions: "/solutions",
  Contact: "/contact",
};
